
export enum 集計種別型 {
  在庫場所指定なし = '在庫場所指定なし',
  在庫場所指定あり = '在庫場所指定あり',
  全部署集計 = '全部署集計',
}

export enum 商品区分型 {
    医薬品 = '医薬品',
    その他品 = 'その他品',
}
